import { render, staticRenderFns } from "./StepNode.vue?vue&type=template&id=7fdcb9dd&scoped=true&"
import script from "./StepNode.vue?vue&type=script&lang=js&"
export * from "./StepNode.vue?vue&type=script&lang=js&"
import style0 from "./StepNode.vue?vue&type=style&index=0&id=7fdcb9dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdcb9dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fdcb9dd')) {
      api.createRecord('7fdcb9dd', component.options)
    } else {
      api.reload('7fdcb9dd', component.options)
    }
    module.hot.accept("./StepNode.vue?vue&type=template&id=7fdcb9dd&scoped=true&", function () {
      api.rerender('7fdcb9dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/declaration/step/StepNode.vue"
export default component.exports